<template>
    <PublicView>
        <main class="main" v-if="blog">
            <div class="blog-single-area pt-5">

                <div class="breadcrumb-container">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <ul class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/"><i class="fas fa-home"></i></router-link>
                                    </li>
                                    <li class="breadcrumb-item">
                                        <router-link to="/kobler/bai-viet">
                                            Blog
                                        </router-link>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="blog-single-wrapper">
                                <div class="blog-single-content">
                                    <div class="blog-info">
                                        <div class="blog-details">
                                            <h3 class="blog-details-title mb-20">
                                                {{ blog.name }}
                                            </h3>
                                            <div class="article-content" v-html="blog.description"></div>
                                        </div>
                                        <hr class="mr-20" />
                                        <div class="blog-details-tags pb-20">
                                            <h5 style="width: 80px">Tags :</h5>
                                            <ul style="
                          display: flex;
                          flex-wrap: wrap;
                          width: calc(100% - 80px);
                        ">
                                                <li v-for="ta in blogTag" :key="ta">
                                                    <a href="#">{{ ta }}</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div id="blog-comments" class="fb-comments" :data-href="currentHref"
                                            data-width="100%" data-numposts="10"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </PublicView>
</template>
<style lang="less">
.article-content {
    text-align: left;
    font-size: 18px;

    ul {
        padding-left: 30px;

        li {
            list-style: initial;
        }
    }

    p {
        &:empty {
            min-height: 1.5em;
        }
    }
}

.ratio {
    &.ratio-16-9 {
        padding-top: 56.25% !important;
        position: relative;
    }

    .wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
}
</style>
<script>
import PublicView from "@/components/PublicKoblerView.vue";

export default {
    data() {
        return {
            previewImg: "",
            material: null,
            color: null,
        };
    },
    methods: {
        timeString(time) {
            return new Date(time).toLocaleDateString();
        },
        navBlogLink(b) {
            return "/blogs/" + b.alias + "/" + b._id;
        },
        selectColor(c) {
            this.color = c.name;
        },
        selectMaterial(m) {
            this.material = m;
            if (this.color) {
                let colorCheck = this.material.colors.find((i) => i.name == this.color);
                if (!colorCheck) {
                    this.color = null;
                }
            }
        },
        styleColor(c) {
            return "background: " + c;
        },
        version(year, pre = "") {
            let result = [];
            for (let i = 0; i < year.length; i++) {
                let text = year[i].year;
                let vers = [];
                for (let ver in year[i].versions) {
                    vers.push(year[i].versions[ver].v);
                }
                if (vers.length > 0) {
                    result.push(vers.map((i) => pre + i + " " + text).join(", "));
                } else {
                    result.push(text);
                }
            }
            return result.length > 0 ? result.join(", ") : "";
        },
        blogLink(id, alias) {
            return "/blog/" + alias + "/" + id;
        },
        numberFormat(num) {
            return new Intl.NumberFormat("vi-VN", {
                style: "currency",
                currency: "VND",
            }).format(num);
        },
    },
    mounted() {
        console.log(this.blog);
        if (
            this.blog &&
            Array.isArray(this.blog.images) &&
            this.blog.images.length > 0
        ) {
            this.previewImg = this.blog.images[0];
        }
        console.log(window.FB);
        if (window.FB && this.$el.querySelector("#blog-comments")) {
            window.FB.XFBML.parse(
                this.$el.querySelector("#blog-comments").parentNode
            );
        }
    },
    components: {
        PublicView,
    },
    computed: {
        currentHref() {
            return window.location.href;
        },
        blogTag() {
            if (this.blog && this.blog.tag) {
                return this.blog.tag.split(",").map((i) => i.trim());
            } else {
                return [];
            }
        },
        articleGroup() {
            if (this.navData) {
                return this.navData.articleGroup;
            }
            return null;
        },
        navData() {
            return this.$store.getters.navData;
        },
        blogs() {
            let blogs = this.$store.getters.blogs;
            return blogs;
        },
        blogsLQ() {
            if (this.blogs && this.blog) {
                let allWithPoint = this.blogs
                    .filter((i) => i._id != this.$route.params.id)
                    .map((n) => {
                        let point = 0;
                        if (typeof n.tag == "string") {
                            let tag = n.tag.split(",").map((i) => i.trim().toLowerCase());
                            let blogTag = this.blogTag;
                            for (let y = 0; y < blogTag.length; y++) {
                                for (let x = 0; x < tag.length; x++) {
                                    if (tag[x].indexOf(blogTag[y].toLowerCase()) != -1) {
                                        point++;
                                    }
                                }
                            }
                        }
                        return {
                            point,
                            blog: n,
                        };
                    });
                allWithPoint.sort(function (a, b) {
                    return b.point - a.point;
                });
                allWithPoint = allWithPoint
                    .filter((i) => i.point > 0)
                    .filter((i, k) => k < 5)
                    .map((i) => i.blog);
                return allWithPoint;
            } else {
                return [];
            }
        },
        blog() {
            let blog = this.$store.getters.blog(this.$route.params.id);
            return blog;
        },
    },
    watch: {
        blog(v) {
            if (Array.isArray(v.images) && v.images.length > 0) {
                this.previewImg = v.images[0];
                if (window.FB && this.$el.querySelector("#blog-comments")) {
                    window.FB.XFBML.parse(
                        this.$el.querySelector("#blog-comments").parentNode
                    );
                }
            }
        },
    },
};
</script>